import React from "react";
import ContactForm from "./ContactForm";
import { FiSmartphone, FiMail, FiMapPin } from "react-icons/fi";

const ContactOne = () => {
  return (
    <div className="mx-4">
      <div className="row justify-content-center">
        <div className="col-lg-6 text-center">
          <ContactForm formStyle="contact-form-1" />
        </div>
      </div>

      <div className="row mt--40">
        <div className="col-lg-12">
          <div className="rn-contact-address">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-address">
                  <div className="icon">
                    <FiSmartphone />
                  </div>
                  <div className="inner">
                    <h4 className="title">Phone Number</h4>
                    <p>
                      <a href="tel:9172683407">(917) 268-3407</a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-address">
                  <div className="icon">
                    <FiMail />
                  </div>
                  <div className="inner">
                    <h4 className="title">Email Address</h4>
                    <p>
                      <a href="mailto:contact@moftahsolutions.com">
                        contact@moftahsolutions.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-address">
                  <div className="icon">
                    <FiMapPin />
                  </div>
                  <div className="inner">
                    <h4 className="title">Our Location</h4>
                    <p>New York City</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactOne;
